import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Filter } from '../models/filter-models';
import { FormsModule } from '@angular/forms';
import { FilterService } from '../services/filter.service';
import { BaseComponent } from '../common/base.component';
import { CustomRuleGroupsListComponent } from '../common/custom-rules/custom-rule-groups-list/custom-rule-groups-list.component';
import { CustomRuleGroupsTabController } from '../common/custom-rules/custom-rule-groups-tab.controller';

@Component({
  selector: 'app-custom-rules-tab',
  templateUrl: './custom-rules-tab.component.html',
  imports: [FormsModule, CustomRuleGroupsListComponent]
})
export class CustomRulesTabComponent extends BaseComponent implements OnInit, OnChanges {
  @Input({ required: true }) filter!: Filter;

  groupsCtrl!: CustomRuleGroupsTabController;

  constructor(private filterService: FilterService) {
    super();
  }

  ngOnInit(): void {
    this.initGroupsCtrl();
    this.groupsCtrl.refreshUiState();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filter']) {
      this.initGroupsCtrl();
      this.groupsCtrl?.refreshUiState();
    }
  }

  private initGroupsCtrl(): void {
    this.groupsCtrl = new CustomRuleGroupsTabController(
      () => this.filter.customRuleGroups,
      () => this.filter,
      () => this.filterService.updateFilter(),
      'Custom Rule Group',
    );
  }

  updateFilter() {
    this.groupsCtrl.updateFilter();
  }
}
